import Vue from "vue";
import Country from "../../classes/Billing/Country";

const state = {
    currencies: undefined,
};

const getters = {
    countries(state) {
        return state.countries;
    },
};

const mutations = {
    setCountries(state, countries) {
        state.countries = countries.map(country => new Country(country)).sort((a, b) => a.name > b.name ? 1 : -1);
    },
};

const actions = {
    async getCountries({ commit }) {
        const response = await Vue.prototype.$diceAPI.getCountries();
        commit("setCountries", response.data.map(country => new Country(country)));
    },
    setCountries({ commit }, countries) {
        commit("setCountries", countries);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};